import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    alignSelf: 'center',
    display: 'flex',
    gap: '1rem',
  },
  root: {
    display: 'flex',
  },
}));

export default useStyles;
